import { QrCodeIcon } from "@heroicons/react/24/outline";
import { useAuth } from "@via/hooks/useAuth";
import { ROUTES } from "@via/utils/constants.tsx";
import { isScanAvailable } from "@via/utils/scan";
import { type JSX } from "react";
import { Link } from "react-router-dom";

/** Opens the scanner scoped to one sample tracker, so a code from elsewhere asks before leaving. */
export default function ScanButton({
  projectId,
}: {
  projectId: string;
}): JSX.Element | null {
  const { config } = useAuth();
  if (!projectId || !isScanAvailable(config)) return null;
  return (
    <Link
      to={`${ROUTES.SCAN}?project=${encodeURIComponent(projectId)}`}
      className="inline-flex items-center gap-1 rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-700 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50">
      <QrCodeIcon className="h-5 w-5" aria-hidden="true" />
      Scan
    </Link>
  );
}
